const INITIAL_STATE = {
    sections: [],
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'SET_SECTIONS':
            return {
                ...state,
                sections: action.sections,
            };

        case 'CLEAR_SECTIONS':
            return {
                ...state,
                sections: INITIAL_STATE.sections
            };

        default:
            return state;
    }
}
